export default __webpack_public_path__ + "static/media/img-try.b83a2aa6.svg";